import type { ReactElement } from "react";
import { CmtsAdminNotificationsContainer } from "../../core/containers/domain/administrationRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsAdminNotificationsContainer runtime={props.runtime} />;
}

export default Component;
